import { HeaderTabs } from '.';
import { type SdmModuleSpecsFragment } from '../../../../api/fragments/SdmModuleSpecs';
import Authorization from './Authorization';
import BankIntegrations from './BankIntegrations';
import SalesForce from './SalesForces';
import SalesPersonCodeMappings from './SalesPersonCodeMappings';

export type SdmModuleDetailsInnerProps = {
    activeTab: HeaderTabs;
    module: SdmModuleSpecsFragment;
    openBankIntegrationDrawer: (bankIntegrationId?: string) => void;
};

const SdmModuleDetailsInner = ({ activeTab, module, openBankIntegrationDrawer }: SdmModuleDetailsInnerProps) => {
    switch (activeTab) {
        case HeaderTabs.SalesForce:
            return <SalesForce module={module} />;

        case HeaderTabs.BankIntegrations:
            return <BankIntegrations module={module} openBankIntegrationDrawer={openBankIntegrationDrawer} />;

        case HeaderTabs.Authorization:
            return <Authorization module={module} />;

        case HeaderTabs.SalesPersonCodeMappings:
            return <SalesPersonCodeMappings module={module} />;

        default:
            return null;
    }
};

export default SdmModuleDetailsInner;
